// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2fT7j","info":"UpdateTermsInfo_info__3HZKG"};